import { motion } from "framer-motion";
import { Quotes, Star } from "@phosphor-icons/react";

const ITEMS = [
  {
    quote:
      "Flat tyre on the expressway at midnight. Tapped request, a crew reached me in 15 minutes. Genuinely lifesaving.",
    name: "Ananya R.",
    role: "Sedan owner · Pune",
  },
  {
    quote:
      "Battery died in a basement parking. They jump-started and replaced the cell on the spot. No towing drama.",
    name: "Vikram S.",
    role: "SUV owner · Delhi",
  },
  {
    quote:
      "Got comprehensive insurance issued in minutes while my car was being serviced. Everything digital.",
    name: "Meera K.",
    role: "Hatchback owner · Bengaluru",
  },
];

export const Testimonials = () => {
  return (
    <section className="relative bg-rescue-bg py-24 sm:py-32">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="mb-14 max-w-2xl">
          <span className="text-rescue-primary font-semibold uppercase tracking-[0.3em] text-xs">
            From the roadside
          </span>
          <h2 className="font-display uppercase tracking-tighter text-white text-5xl sm:text-6xl lg:text-7xl leading-[0.9] mt-4">
            Drivers who got moving again.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {ITEMS.map((t, i) => (
            <motion.div
              key={i}
              data-testid={`testimonial-${i}`}
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08 }}
              className="bg-rescue-surface border border-white/10 p-8 flex flex-col"
            >
              <Quotes weight="fill" size={34} className="text-rescue-primary" />
              <p className="text-white/80 text-lg leading-relaxed mt-5 flex-1">{t.quote}</p>
              <div className="flex gap-1 mt-6">
                {Array.from({ length: 5 }).map((_, s) => (
                  <Star key={s} weight="fill" size={15} className="text-rescue-primary" />
                ))}
              </div>
              <div className="mt-4 pt-4 border-t border-white/10">
                <div className="font-display uppercase text-xl text-white leading-none">{t.name}</div>
                <div className="text-white/50 text-sm mt-1">{t.role}</div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
